export default "__VITE_ASSET__BXVUROQ___"